import { Component, HostBinding, Input, OnInit, ViewEncapsulation } from '@angular/core';

export interface AvatarGroupItem {
  src?: string;
  name?: string;
  onClick?: any;
}

@Component({
  selector: 'glxy-avatar-group',
  templateUrl: './avatar-group.component.html',
  styleUrls: ['./avatar-group.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AvatarGroupComponent implements OnInit {
  @HostBinding('class') class = 'glxy-avatar-group';

  @Input({ required: true }) avatarList: AvatarGroupItem[] = [];
  @Input() limit = 3;
  @Input() avatarWidth = 36;

  hasExtraAvatars = false;

  shownAvatars: AvatarGroupItem[] = [];
  extraAvatars: AvatarGroupItem[] = [];

  ngOnInit(): void {
    this.prepareAvatarArrays();
  }

  prepareAvatarArrays(): void {
    if (this.avatarList.length > this.limit) {
      this.hasExtraAvatars = true;
      this.shownAvatars = this.avatarList.slice(0, this.limit);
      this.extraAvatars = this.avatarList.slice(this.limit, this.avatarList.length);
    } else {
      this.shownAvatars = this.avatarList;
    }
  }
}
